import mappingActionTypes from './MappingConstants';
import { EXCEL_FILE, getFileTypeCategory } from 'shared/helpers/fileTransferHelper';
import { SET_PROFILE_FOR_EDITION } from '../profiles/ProfilesConstants';

const initialState = {
  divisions: [],
  mappingInfo: []
};

const MappingFileReducer = (state = initialState, action) => {
  switch(action.type) {
    case mappingActionTypes.FETCH_IMPORT_MAPPING_DATA_SUCCESS:
      return {
        ...state,
        divisions: action.mappingInfo.map(container => container.container),
        mappingInfo: action.mappingInfo
      };
    case mappingActionTypes.UPDATE_CONTAINER_LIST:
      return { ...state, divisions: action.containers };
    case mappingActionTypes.RESET_IMPORT_MAPPING_DATA_SUCCESS:
      return {
        ...state,
        mappingInfo: (getFileTypeCategory(action.fileExtension) === EXCEL_FILE) ? state.mappingInfo : []
      };
    case SET_PROFILE_FOR_EDITION:
      return {
        ...state,
        divisions: action.profile.map.sourceFields.map(container => container.container),
        mappingInfo: action.profile.map.sourceFields};
    default:
      return { ...state };
  }
};

export default MappingFileReducer;




// WEBPACK FOOTER //
// ./src/redux/mapping/MappingFileReducer.js